<div class="sign-up-page">
  <div class="container-fluid">
    <div class="row">
      <div class="col-xs-12 col-md-6 left-side">
        <achoo-placeholder [placeholderId]="'loginComponentHolder'" [normalPlaceholder]="true" [isFullscreenLoader]="true">
          <router-outlet></router-outlet>
        </achoo-placeholder>
      </div>
      <div class="col-xs-12 col-md-6 right-side">
        <div class="background"></div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/influencer-auth/influencer-auth.component.html